@import "../shared.css";

:host {
	display: flex;
	align-items: center;
	flex-direction: row;
	position: relative;
	gap: .5rem;
	padding-inline: var(--input-padding-side);
	background-color: rgb(var(--smoothly-input-background));
	box-sizing: border-box;
	background-color: rgb(var(--smoothly-input-background));
	color: rgb(var(--smoothly-input-foreground));
}
:host:has(>.smoothly-checkbox-end-slot:not(:empty)) {
	padding-right: 0;
}

:host>input {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	height: 1.25rem;
	width: 1.25rem;
	border-radius: 0.25rem;
	border: 1px solid rgb(var(--smoothly-input-foreground));
	color: rgb(var(--smoothly-input-foreground));
	display: block;
}
:host([checked][looks=transparent])>input, /* Override shared.css transparent styling */
:host([checked])>input {
	background-color: rgb(var(--smoothly-input-foreground));
}

:host:not([readonly]):not([disabled])>input,
:host:not([readonly]):not([disabled])>label {
	cursor: pointer;
}
:host>label:empty {
	display: none;
}

:host([disabled]),
:host([disabled])>* {
	cursor: not-allowed;
}

:host>smoothly-icon {
	position: absolute;
	z-index: 1;
	pointer-events: none;
	--smoothly-color-contrast: var(--smoothly-input-background);
	/* outline: 2px solid blue; */
}

:host[looks="transparent"] {
	background-color: transparent;
}
/* overwrite shared.css styling */
:host[looks="transparent"]:not([readonly]):focus-within {
	outline-color: transparent;
}

:host>.smoothly-checkbox-end-slot {
	margin-left: auto;;
}
:host>.smoothly-checkbox-end-slot:empty {
	display: none;
}
